<template>
  <div class="my_drag">
    <div class="left lefts" @dragstart="leftDragStart">
      <div>
        <el-select
          v-model="hospitalId"
          placeholder="选择模版"
          class="search_input"
          clearable
          @change="imports"
        >
          <el-option
            v-for="item in hospitallist"
            :key="item.name"
            :label="item.name"
            :value="item.template"
          ></el-option>
        </el-select>
      </div>
      <div class="left">
        <span
          draggable
          v-for="(data, index) in dragFieldList"
          :key="`left_` + index"
          :data-index="index"
          v-text="data.label"
        ></span>
      </div>
    </div>
    <div :class="[`center`]">
      <div
        v-if="!prevStatus"
        :class="[`editor`]"
        @drop="editDragDrop"
        @dragover="allowDrop"
        @click="clickDragEditor"
        @contextmenu.prevent
      >
        <div
          :id="`e` + index"
          @mousedown="editMousedown($event, index)"
          @click.stop="clickDragElement($event, index)"
          v-for="(data, index) in editorList"
          :data-index="index"
          :key="index"
          :style="data.style"
          :model="data.model"
        >
          <span v-html="data.editLabel"></span>
          <span :style="data.editStyle">{{ data.editValue }}</span>
        </div>
      </div>
      <div class="editor_prev position_horizontal_center" v-if="prevStatus">
        <div
          v-for="(data, index) in prevEditorList"
          :style="data.style"
          :model="data.model"
          :key="index"
        >
          <span v-html="data.editLabel"></span>
          <span :style="data.editStyle">{{ data.editValue }}</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div v-show="clickElementData != null">
        <div class="right_attrs">
          <b>字体大小</b>
          <el-input
            size="small"
            placeholder="请输入内容"
            v-model="fontSizeValue"
            type="number"
          ></el-input>
        </div>
        <div class="right_attrs">
          <b>字体粗细</b>
          <el-select
            size="small"
            v-model="fontWeightValue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in fontWeightList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="right_attrs" v-show="canEditContent">
          <b>内容</b>
          <el-input
            size="small"
            placeholder="请输入内容"
            type="text"
            autosize
            v-model="editContentValue"
          ></el-input>
        </div>
        <div class="right_action">
          <el-button size="small" type="danger" @click="deleteDragElement"
            >删除组件</el-button
          >
        </div>
      </div>
      <div class="right_final_action">
        <el-button size="small" type="success" @click="prev">
          {{ prevStatus ? `取消预览` : `预览模板` }}
        </el-button>
        <el-button @click="dialogFormVisible = true" size="small" type="warning"
          >保存模板</el-button
        >
      </div>
      <div class="right_final_action">
        <!-- <p>测试按钮</p> -->
        <!-- <el-button @click="imports" size="small" type="success"
          >导入模板</el-button
        > -->
        <!-- <el-button @click="exports" size="small" type="success"
          >导出模板</el-button
        > -->
      </div>

      <div v-show="false" v-html="importHtml" id="originTemplateData"></div>
      <div v-show="false" id="exportHtmlLayout">
        <div
          v-for="(data, index) in exportList"
          :style="data.style"
          :model="data.model"
          :key="index"
        >
          <span v-html="data.editLabel"></span>
          <span :style="data.editStyle">{{ data.editValue }}</span>
        </div>
      </div>
    </div>
    <!-- 添加弹框 -->
    <el-dialog
      top="15vh"
      :visible.sync="dialogFormVisible"
      width="20%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          prop="value"
          label="模版名称:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入模版名称"
            v-model="value"
            autocomplete="off"
          ></el-input>
           <el-switch
            v-model="defaults"
            active-text="设为默认"
            inactive-text="不设为默认模版"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="login_Edit" @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="ok_Edit" type="primary" @click="exports">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "drag",
  data() {
    return {
      defaults:false,
      dialogFormVisible: false,
      form: {},
      rules: {},
      value: "",
      formLabelWidth: "",
      dom: "",
      hospitalId: "",
      hospitallist: "",
      dragFieldList: [
        {
          label: "报告标题",
          editLabel: "报告标题",
          canEditContent: true,
          focus: false,
          model: "title",
          style: {
            width: "100%",
            fontSize: "20px",
            textAlign: "center",
            display: "inline-block",
            border: 0,
            fontWeight: "bold",
          },
        },
        {
          label: "分隔线",
          editLabel: "",
          focus: false,
          model: "line",
          style: {
            width: "100%",
            height: "2px",
            display: "inline-block",
            background: "#000000",
          },
        },
        {
          label: "检查号",
          editLabel: "检查号:",
          editValue: "ABCDEFG0123456789",
          focus: false,
          model: "studyNo",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "仪器型号",
          editLabel: "仪器型号:",
          editValue: "ABCDEFG-000000",
          focus: false,
          model: "deviceNo",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "姓名",
          editLabel: "姓 名:",
          editValue: "仰和医疗",
          focus: false,
          model: "username",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "性别",
          editLabel: "性 别:",
          editValue: "男",
          focus: false,
          model: "gender",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "年龄",
          editLabel: "年 龄:",
          editValue: "100 岁",
          focus: false,
          model: "age",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "检查日期",
          editLabel: "检查日期:",
          editValue: "0000-00-00 00:00:00",
          focus: false,
          model: "studyDatetime",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "申请科室",
          editLabel: "申请科室:",
          editValue: "某某某某科",
          focus: false,
          model: "department",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "门诊号",
          editLabel: "门诊号:",
          editValue: "PART-123456",
          focus: false,
          model: "checkNo",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "床号",
          editLabel: "床号:",
          editValue: "BED-123456",
          focus: false,
          model: "bedNo",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "住院号",
          editLabel: "住 院 号:",
          editValue: "LIVE-123456",
          focus: false,
          model: "liveNo",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "申请医生",
          editLabel: "申请医生:",
          editValue: "某某申请医生",
          focus: false,
          model: "applyDoctor",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "临床诊断",
          editLabel: "临床诊断:",
          editValue: "某某某某某某诊断",
          focus: false,
          model: "diagnosis",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "检查部位",
          editLabel: "检查部位:",
          editValue: "某某某某某某某某部位",
          focus: false,
          model: "body",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "影像所见",
          editLabel: "影像所见:",
          editValue: "某某某某某某某某所见",
          focus: false,
          model: "desc",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
            display: "block",
            wordBreak:'break-all'
          },
        },
        {
          label: "影像提示",
          editLabel: "影像提示:",
          editValue: "某某某某某某某某提示",
          focus: false,
          model: "remind",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
            display: "block",
            wordBreak:'break-all'
          },
        },
        {
          label: "报告医师",
          editLabel: "报告医师:",
          editValue: "某某报告医师",
          focus: false,
          model: "checkDoctor",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "审核医师",
          editLabel: "审核医师:",
          editValue: "某某审核医师",
          focus: false,
          model: "examDoctor",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "报告日期",
          editLabel: "报告日期:",
          editValue: "0000-00-00 00:00:00",
          focus: false,
          model: "reportDatetime",
          style: {
            display: "inline-block",
            border: 0,
          },
          editStyle: {
            fontWeight: "normal",
            fontSize: "16px",
          },
        },
        {
          label: "备注信息",
          editLabel: "备注信息",
          model: "remark",
          canEditContent: true,
          focus: false,
          style: {
            display: "inline-block",
            border: 0,
          },
        },
   {
						label: '二维码',
						editLabel: '',
						model: 'qrcode',
						focus: false,
						style: {
							display: 'inline-block',
							border: 0,
							width: '100px',
							height: '100px',
							backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAABlBMVEX///8AAABVwtN+AAABDElEQVRo3u3ZQQ7DIAwEwOTkZ+X/v8gzuLUIb+wYpNwqNfbuARGY3lY0tBvzFzk+nvGog9yWT7L8TGxYmXdlk77kg0bI8rLRhnZ1yDb3UQ+yGkyw/sh0iSwd081n1kNWiWnWSo2QJWaWyCyBWX3IErKema0BCyFLya6GtGuma/4i0ciSM0+LDIfDmOiTrod7CNmrmccLcxpDVQSbXh8IIUvKUBpd8k/hINGQJWf2qoiDxGYxR2TbTpaITTknOJhbfJQsKZtvlLeuYJesBtPBH53FL5LIuhCyF7LlryXE7wuReZHwqoGBrALD7H6QkJVhy69PK8OhsZPVYBpj8eJJlphZQkO8OmS1GfPDfAHsX5S+uaOtDgAAAABJRU5ErkJggg==)',
							backgroundSize:'cover',
						},
					},
             {
						label: '报告医师签名',
						editLabel: '',
						model: 'checksign',
						focus: false,
						style: {
							display: 'inline-block',
							border: 0,
							width: '100px',
							height: '50px',
							backgroundImage: 'url(data:image/png;base64,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)',
							backgroundSize:'100px 50px',
						},
					},
              {
						label: '审核医师签名',
						editLabel: '',
						model: 'examsign',
						focus: false,
						style: {
							display: 'inline-block',
							border: 0,
							width: '100px',
							height: '50px',
							backgroundImage: 'url(data:image/png;base64,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)',
							backgroundSize:'100px 50px',
						},
					}

      ],
      editorList: [],
      prevEditorList: [],
      editWidth: document.body.clientWidth * 0.7,
      fontSizeValue: null,
      fontWeightValue: null,
      editContentValue: null,
      fontWeightList: [
        {
          name: "细体",
          value: "lighter",
        },
        {
          name: "普通",
          value: "normal",
        },
        {
          name: "加粗",
          value: "bold",
        },
      ],
      clickElementData: null,
      canEditContent: false,
      prevStatus: false,
      importHtml: null,
      exportList: null,
    };
  },
  created() {
    this.getListMyHospital();
  },
  methods: {
    getListMyHospital() {
      depot
        .get({
          url: "/v1/report/template/listDefaultTemplates",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res);
          this.hospitallist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    leftDragStart(e) {
      e.dataTransfer.setData("index", e.target.dataset.index);
    },
    editDragDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.dataTransfer.getData("index")) {
        var left = e.layerX;
        var top = e.layerY;
        let comps = JSON.parse(
          JSON.stringify(this.dragFieldList[e.dataTransfer.getData("index")])
        );
        if (comps.style.width === "100%") {
          left = 0;
        }
        comps.style.position = "absolute";
        comps.style.top = top + "px";
        comps.style.left = left + "px";
        this.editorList.push(comps);
      }
    },
    editMousedown(event, index) {
      if (event.target.nodeName === "SPAN") {
        let outer = event.target.parentNode;
        var mousedown = document.createEvent("MouseEvents");
        var rect = outer.getBoundingClientRect();
        var x = rect.x + event.layerX;
        var y = rect.y + event.layerY;
        mousedown.initMouseEvent(
          "mousedown",
          true,
          true,
          window,
          0,
          x,
          y,
          x,
          y,
          false,
          false,
          false,
          false,
          0,
          null
        );
        outer.dispatchEvent(mousedown);
        return false;
      }

      let comps = this.editorList[index];
      comps.move = true;

      var event = event || window.event;
      var _target = event.target;
      var startx = event.clientX;
      var starty = event.clientY;
      var sb_bkx = startx - event.target.offsetLeft;
      var sb_bky = starty - event.target.offsetTop;
      var ww = document.documentElement.clientWidth;
      var wh = window.innerHeight;
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }
      let vm = this;
      document.onmousemove = function (ev) {
        var event = ev || window.event;
        var scrolltop =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (
          event.clientY < 0 ||
          event.clientX < 0 ||
          event.clientY > wh ||
          event.clientX > ww
        ) {
          return false;
        }
        var endx = event.clientX - sb_bkx;
        var endy = event.clientY - sb_bky;
        if (endx < 0) {
          endx = 0;
        }
        if (endy < 0) {
          endy = 0;
        }
        comps.style.left = endx + "px";
        comps.style.top = endy + "px";
        /*					_target.style.left = endx + 'px';
										_target.style.top = endy + 'px';*/
      };

      document.onmouseup = function () {
        let comps = vm.editorList[index];
        comps.move = false;
        document.onmousemove = null;
      };
    },
    allowDrop(e) {
      e.preventDefault();
    },
    clickDragEditor() {
      if (this.clickElementData == null) {
        return false;
      }
      this.editorList[this.clickElementData.index].style.outline = "0";
      this.clickElementData = null;
    },
    clickDragElement(e, index) {
      this.clickElementData = {
        index: index,
        event: e,
      };
      this.editorList[index].style.outline = "1px solid #70c0ff";
      for (let i = 0; i < this.editorList.length; i++) {
        if (i === index) {
          continue;
        }
        this.editorList[i].style.outline = "0";
      }
      this.canEditContent = this.editorList[index].canEditContent;
      let fontSize, fontWeight;
      if (e.target.nodeName === "SPAN") {
        fontSize = e.target.parentNode.style["font-size"];
        if (fontSize === "") {
          fontSize = window.getComputedStyle(e.target).fontSize;
        }
        fontWeight = e.target.parentNode.style["font-weight"];
        if (fontWeight === "") {
          fontWeight = "normal";
        }
      } else {
        fontSize = e.target.style["font-size"];
        if (fontSize === "") {
          fontSize = window.getComputedStyle(e.target).fontSize;
        }
        fontWeight = e.target.style["font-weight"];
        if (fontWeight === "") {
          fontWeight = "normal";
        }
      }
      this.fontSizeValue = parseInt(fontSize);
      this.fontWeightValue = fontWeight;
      this.editContentValue = this.editorList[index].editLabel;
    },
    deleteDragElement() {
      this.$confirm("您将删除选中的组件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.clickElementData == null) {
            return false;
          }
          this.editorList.splice(this.clickElementData.index, 1);
          this.clickElementData = null;
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {});
    },
    imports(e) {
      let html = e;
      // '<div data-v-6d601c66="" model="title" style="width: 100%; font-size: 25px; text-align: center; display: inline-block; border: 0px; font-weight: bold; position: absolute; top: 0px; left: 0px; outline: 0px;"><span data-v-6d601c66="">XXXXXX检查报告单  </span> <span data-v-6d601c66=""></span></div><div data-v-6d601c66="" model="studyNo" style="display: inline-block; border: 0px; position: absolute; top: 46px; left: 0px; outline: 0px; font-size: 16px; font-weight: normal;"><span data-v-6d601c66="">检查号:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{studyNo}</span></div><div data-v-6d601c66="" model="line" style="width: 100%; height: 2px; display: inline-block; background: rgb(0, 0, 0); position: absolute; top: 70px; left: 0px; outline: 0px;"><span data-v-6d601c66=""> </span> <span data-v-6d601c66=""></span></div><div data-v-6d601c66="" model="username" style="display: inline-block; border: 0px; position: absolute; top: 78px; left: 0px; outline: 0px;"><span data-v-6d601c66="">姓 名:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{username}</span></div><div data-v-6d601c66="" model="gender" style="display: inline-block; border: 0px; position: absolute; top: 80px; left: 234px; outline: 0px; font-size: 16px; font-weight: normal;"><span data-v-6d601c66="">性 别:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{gender}</span></div><div data-v-6d601c66="" model="age" style="display: inline-block; border: 0px; position: absolute; top: 82px; left: 501px; outline: 0px;"><span data-v-6d601c66="">年 龄:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{age}</span></div><div data-v-6d601c66="" model="studyDatetime" style="display: inline-block; border: 0px; position: absolute; top: 45px; left: 441px; outline: 0px;"><span data-v-6d601c66="">检查日期:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{studyDatetime}</span></div><div data-v-6d601c66="" model="department" style="display: inline-block; border: 0px; position: absolute; top: 121px; left: 0px; outline: 0px;"><span data-v-6d601c66="">申请科室:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{department}</span></div><div data-v-6d601c66="" model="checkNo" style="display: inline-block; border: 0px; position: absolute; top: 118px; left: 233px; outline: 0px;"><span data-v-6d601c66="">门诊号:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{checkNo}</span></div><div data-v-6d601c66="" model="bedNo" style="display: inline-block; border: 0px; position: absolute; top: 118px; left: 500px; outline: 0px;"><span data-v-6d601c66="">床号:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{bedNo}</span></div><div data-v-6d601c66="" model="liveNo" style="display: inline-block; border: 0px; position: absolute; top: 158px; left: 0px; outline: 0px; font-size: 16px; font-weight: normal;"><span data-v-6d601c66="">住 院 号:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{liveNo}</span></div><div data-v-6d601c66="" model="applyDoctor" style="display: inline-block; border: 0px; position: absolute; top: 158px; left: 234px; outline: 0px;"><span data-v-6d601c66="">申请医生:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{applyDoctor}</span></div><div data-v-6d601c66="" model="diagnosis" style="display: inline-block; border: 0px; position: absolute; top: 201px; left: 0px; outline: 0px;"><span data-v-6d601c66="">临床诊断:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{diagnosis}</span></div><div data-v-6d601c66="" model="body" style="display: inline-block; border: 0px; position: absolute; top: 201px; left: 361px; outline: 0px;"><span data-v-6d601c66="">检查部位:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{body}</span></div><div data-v-6d601c66="" model="desc" style="display: inline-block; border: 0px; position: absolute; top: 261px; left: 0px; outline: 0px; font-size: 16px; font-weight: normal;"><span data-v-6d601c66="">影像所见:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px; display: block; text-indent: 4em;">{desc}</span></div><div data-v-6d601c66="" model="remind" style="display: inline-block; border: 0px; position: absolute; top: 678px; left: 0px; outline: 0px;"><span data-v-6d601c66="">影像提示:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px; display: block; text-indent: 4em;">{remind}</span></div><div data-v-6d601c66="" model="line" style="width: 100%; height: 2px; display: inline-block; background: rgb(0, 0, 0); position: absolute; top: 958px; left: 0px; outline: 0px;"><span data-v-6d601c66=""> </span> <span data-v-6d601c66=""></span></div><div data-v-6d601c66="" model="remark" style="display: inline-block; border: 0px; position: absolute; top: 973px; left: 13px; outline: 0px; font-size: 16px; font-weight: normal;"><span data-v-6d601c66="">****自定义的备注信息*****  </span> <span data-v-6d601c66=""></span></div><div data-v-6d601c66="" model="checkDoctor" style="display: inline-block; border: 0px; position: absolute; top: 937px; left: 0px; outline: 0px;"><span data-v-6d601c66="">报告医师:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{checkDoctor}</span></div><div data-v-6d601c66="" model="examDoctor" style="display: inline-block; border: 0px; position: absolute; top: 936px; left: 203px; outline: 0px;"><span data-v-6d601c66="">审核医师:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{examDoctor}</span></div><div data-v-6d601c66="" model="reportDatetime" style="display: inline-block; border: 0px; position: absolute; top: 936px; left: 450px; outline: 0px;"><span data-v-6d601c66="">报告日期:</span> <span data-v-6d601c66="" style="font-weight: normal; font-size: 16px;">{reportDatetime}</span></div>';
      this.importHtml = html;
      let loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
        let dom = document.getElementById("originTemplateData");
        let childs = dom.children;
        for (let i = 0; i < childs.length; i++) {
						let tempStyle = childs[i].attributes['style'].value;
						let model = childs[i].attributes['model'].value;
						if (model === "qrcode") {
							tempStyle = tempStyle.replace('url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAABlBMVEX///8AAABVwtN+AAABDElEQVRo3u3ZQQ7DIAwEwOTkZ+X/v8gzuLUIb+wYpNwqNfbuARGY3lY0tBvzFzk+nvGog9yWT7L8TGxYmXdlk77kg0bI8rLRhnZ1yDb3UQ+yGkyw/sh0iSwd081n1kNWiWnWSo2QJWaWyCyBWX3IErKema0BCyFLya6GtGuma/4i0ciSM0+LDIfDmOiTrod7CNmrmccLcxpDVQSbXh8IIUvKUBpd8k/hINGQJWf2qoiDxGYxR2TbTpaITTknOJhbfJQsKZtvlLeuYJesBtPBH53FL5LIuhCyF7LlryXE7wuReZHwqoGBrALD7H6QkJVhy69PK8OhsZPVYBpj8eJJlphZQkO8OmS1GfPDfAHsX5S+uaOtDgAAAABJRU5ErkJggg==\");', "qrcode-image;");
						}
             	if (model === "checksign") {
							tempStyle = tempStyle.replace('url(\"data:image/png;base64,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\");', "checksign;");
						}
            	if (model === "examsign") {
							tempStyle = tempStyle.replace('url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAR8AAABACAYAAAAj+HPbAAATOUlEQVR4nO2dX4xd11XGf/fOaIbpxI5cY9cOBQ9RK9c0BDduIMEkdmNqtQoxTQDVbQoFTLFaCq2TUjfIaU1Tl0BLaNoOVEHFtYUacIVTZEtNFKtBkauOrGhk+SEaRap0n4z6MC8jXni6PHx3cfbdd59zz7+5954z55O2kuu5f86ffdZe61vfWhvKx8w6fGeDBg0aJOJtwGvAJWDvmI+lQYMGE4zpkr9vqvedvwX8DPAHwH+X/BsNGowKtwCz3r/9L/A/YziWBkOwCTgPdIHrwO7xHk6DBqnQBrYBR4HngVeBNTSPQ2MF+Bzw5nEcbIN+7ALejVaJYzTGp8Fk41ZgP/Ak8CKwSryhSRrngM0jPvZxooWu3dy4D8TFzwE/BBaBO4EldHPeO86DatCgh3lkbJ4ClslnaELjNcRzbgRsAs4gj3AV+Cjl0za58dvowP4JEc5d4FkGY+YGDUaB7cCfAlfIblTWgBeAvwKeAC7HvO88eijrjh1EdIqN14F3jvOgXGwBLjDBB1gjzAAfAj4B/MKYj2XSsBX4FsmcTYjDOYsog72IaG4jKuFSzGc6wIHRnNJY8XbgJcIG+p4xHtcA9hCFXDaOjPWI6gvzNDvU8yFoAZ8CbgAf6L1OgzngGyQbm2UUgu1HHIaLNnAv8N2Ez18F7sp3WpXCPgafZzM8n2SCwi7DAvA1FBeuoRvcoHzMAl9Fk2ERSRvqhnngObIb2Hcir9v1Ur4DPAr8HnA3/XTANJq3H0eZrjijswqcYMII13XC/cgjDBmeY0yg4XExDfwi+W7ULSiMa5d6RPXDrwI3gb+lvspyO8cV4H2k84BaKNnxMMrEtnv/dbmbZRRO/JhkL8mMzimUjq87WsD7kcEOhZqPkN4LnXjYxPgwWp06RCd7jQmLK3NiH9KPvIdyDWobeCvDSf02MuZbmPAVK4Bp5OJbiPkXiPx8CnkraXAXCpWyEs830Cq/vYwTqQBayLh0CBueB6iB4ZkHDgJfJ3yi7riMHpoqYzfSPa0hIdso0EIP5yn63ecq8hXTwEnC3MtCwuda6IHpBD4bl+X6AcqS7aAGD1oGtNDcDGmeOlSUV5xB4deDwJcZdHNXkUboReRe+yf+IspgVBlb0Xl0gZeBnev4W9PAIeKzNF3gItUz6LMo7e2fSxKneICw4bkO/Dta2E4Dh4G3UD2vsCy0UOQRlyH8NvKIFulXfy8jj/4ocihKw3bk7i4h9/OPSefe34Zi85ChWUb6ic8iz2crOvGQjsDGV1P87qRjF/AjotV1PUj4zWgCJRGmNqoqjlugP3z6PjIaIYQyr2Z4d633gVYM7ya9dxg3FinJAMUx3Y9475tBN/k4WkncE1jpHdDDxBPPLeDXEbcTOqELxE+uKsHCLjuvR0v63jlkxM+RTtdi4rmyuadRwtK/SSHsW5Bh8s//DCWv0DXBB8lubFbQXHIlCZ+iYKj6dsIrht28fcCnUWzsTvhXkUezH7n0ww5iDnic8EOz1vutuqhHfeNTpOxkGl3jb5K+JmkFeUV1IE5bwB2ojCdkQKcRz+XPp1NsjBR5HpikIWkOraLo5AiKbuzaP+K85/sUCOdd7ciw0UGE8eEcP/gO4jmJa8BvUt2VOYR9RHyWKUNvBe5DhiRNceI0WulvkG2FWkLe6UbB/fRzh2vAX7Jx+Zy0iAu91pBn/cuBz8wjZbi991sUMPDDYr8l5FrtJp9xaKEwLBTSXUOkdNX5nRD2E53nTeA/6L/O15GqNgkt4COkNzp2v+4o9UwmG6ESn5PI8JjcYKszbmVjZbSSMI2iDbtu/4U43yRv+TD9kcuXUU+vzEjyep4BbqeYN+LqNXx37gT1jcVbKPs0zFCkWTVCD1fcuMrGa2nyKNmMsy16tdCvlIAZJPBNA38u3kReZy74knRzuf6c4t7IJuBvGLzx50gvFKsarEYoLRmc1mW1mi7zQhd6w81y1YWozwJr62LX4K8ZXuPlzvOJLxmYMPiG/jg5nZMW8BiDN6SM4rHbUXrT93Y+WsJ3TyJmUfiYJuXdRdxXFp1EG3iT89oX4CWln+uKFvAxomtg8ozQgpo0vkBDSqfBAv2Sh0Jp9p1I/FaKJeuhjR5Cn9+5jjiQurm5ZnTiZAPuuIG8lp+n+HVw4+6XULZyo2GB6GH4IfKCQPzDA8Bn0L05GDP+iCgbuUjTHjUJPjdUeLFz02VdiitgZ1G45oYba2iF9lsYVB1ZjE4X+DzlZfJcId1Gy2oZrPVGl2JlALuIPPQ6ZlzLgoX9pcy5EIl5LOd33YrIVb8XyksovV4ntFCNVFIZgxndnzivyxIYukK6Dv0P3RRqinUQeZl1JfNBAlYzwJbZyot5VG7hcpJ7qJ+Xnhf+Ylc4k+oL4JbQDc2KedTHx3/46roif4BkWcIq8DTqNOiSc7kzAg78hlmusnQa9aVxBYgrwO9Sv5V8iqjeq4j730Kh2uOEG8p/FxnxOnKUaeEKETuUVGjqE5ZfJHuufhMSHIYMz74yDnLC4E76JKNjON77209RI6si8IsAXbIvqUBwlBX1o4ItnB2y18vNoLn5WcKK/p+iDK2bOLjRe/8C1feG9pBer+faiFU0j0o7/x2owvcN4F0ZPzuPHgD/5nWoaBl+Svip3ZDR8d+3hsLSIthD5Kn6LSXuJDm7U0iBOmFwF4CPkf5h2Ap8hXSlKY/2vncrKit4gciwX0Ee5i6q6VHuR8/oFbSF0Ak0N/1WIu6Cttb7/9IN71Hge2QjmuMMTxeFYHVUK7s4hm7IVwg3cnfJ0DKI/G1EpOgaIv8MccWU7sjj1U4qzOt5jnScltXEJfVmdheSM6iGycd24Pfp3xWjgxrhWQP6tF045xhfg7ck7/0SqnZoExmpde3b3CabsQg1eFpCB/g68M/061Hcz+1Gocjz9LfdWAP+BaWgq4Bpkie+z6c94f29ha5RmpXEv97uQ7cJ+EfiH6YO0rAUValPCqaQIb2J2qwmwVrDDKuJ6yDq4CDpCfrtyBO4QHwTrpdRwsUfLxNxhuNSoycVkXeRx/4jJqw+LsQtmMZkCwrh3CZg04jreIZ0fUPqUBoQWlncnTxmEX9g6tok+Nf7daKq7t8gvLVJB/gSuu7TRL2Q6yBCtPAyrtfTMHW5NbB7HnkxZYRO0+i63oe2NDpLuIYxbvgL06iwl0ERsD8uEvYCx4ID9BuR8yhWBO2isIhW/PsYXHUuIQ3QIcRfbEXu5xzwS0Qd/85S7RSxz7/cIJIbuF6MHz6F4F/v08BDRNfKH76B8YVhT1Dd8MvOpYNCAxdzJKvLX0VGfJRbHN+CsscHe8f2GXTvzyIDaB5TXnlLGQi1IfHHCtorbqzej5vrj+uT8iSDMWSafjJziBTtUu32qf7D3kVu9jayZw7iOvLFDXchMPjdCqpMPJtRd/mrYe1GXA6jQRiuXippFG4Ylhcu4dlBlrzt/f1pIlf382RrYHUb8ArVNz6hrNN5FJIaSd1heDX1DApV0xqe0wx6i5tR+OG+ryyh46hhnReu0x+Wx3VkuIYat00EVzHhmAL+kOGh4r8xWs8RGAwV3JTbbO/1ClrNzUBlneSHiAzX96hmKYb/ICwjruUfUA1RWsMDg9mypBFS94Z6AJ1jDJOnJJgH9xiD184l91fQeVfVuxsXLLxfJOp9tBcZ8BOIQ/wTxuD5PEDUIc6d6HuJSgyeQSnndyAXOAuJNoWaEdlDkrsx0ZjhhjgdlNV7g0gMl1UrMazFZVIK1A/ZOgzyJFWBheRxCvwW6pTwGNk95hZa6Ix/3IiwuTJxCQkTIXaB/0Sh1CxayY0wcw2SrUKnSf+QuTFnocZEY4Tv9TyLjLZrLD5C9pXDMlVpPR4YNFrrJhAbEaw9asjrKYoj9F+njdbv2TRiE1cKFcrM7EB7+dgN8/t52D5Vw4jNGaKWli5JXdXtcnxi9yH60+3fIN+ktrT8FST7TxNCHSUKYate22W8Vd66w2EIeZdHEj9RH5hQuMMEViSYwrGLhIPvo184Z9mTk844jQjXq8C/0i+uGrY39hLV7EkTIj1db6WoOzuFhF7udYpbpdySjuuEm39XCdbGYT0zLb53WVVSPgvMsZhIr9jPlPyEdC1B846bKEypIobVVb2/4PcbGWjcTdwq5ZPUVS+p2I5C/VfRvvRZsBPxkWl6hM+iMLnuxmcO+BV0PY4iT3rdyiaKIE9D7rRjlcGHtWg/lnHB5P5J51tkl1KXcxt2nVwjaEroqsJtjxonjDR+Ma4RvHV6vMTwnlJu6F9X42P9u272RlGKo41ok7vRzjQnURjnRju2S7Gp7YfCVpwsxuQCkqsf7v3g6YQf84V4Vd5Ncliv4DfIbwT84t2kfrl+Y7iqcmeGBRS6J3E9xi9aiOmX5bjC1RWkNI4LLzaC8QF54V1ksG/P8Lk5FOp/GPg7hlMooXEN7VIcG+Il6Uu+gwyLvb7M4O6RdsPjSLuknjRVQ6j5vmtQzxN+KNJ+t6vTSXoI/cLT60xY5iIj3Nq4pAzXJnSNu0QbMvpw25C8QrhOyTVSdTY+bveDpBYvtyAZzTGy16ktk8zvdkiIBOIeqC+gm2TNsdZivsRuZNwPHCDiL6pseAB+Fm0d7V+rRaR5epF8xmcTKlB0q6WTarLca9pFN/9zyCAdQyv+HqqzUZ5lDt2G8CG4RsOtn3Phekdx7/HvYx2Nz5tRVu8q4sHWEM+1icijyWpo3KjnKIMtY1roOfBbNT+ZdKB+fxiXZ9jfO/C4hyrJ+LgPyXlUklFl+G0zzBvc4fztNeBtGb93F2pn4HoycQbMFxOaqjpusnSQB3uYydSzuImOYY3C/BKU0JzzJRCh97jq+i7V1JklwcJ3y5JuYXg1e9K4AnwadYOcGfLbofrEROMDEVnnd8yzA49bRULGp4VizU7vx5+jHluU+P2Uu2g3EJAsvUu+OjU/ND1L2EP0F4kllFp3MzdJYwV15BuHEWojT8wN2V1JgT/v4uBqqUKG5YTz91Bo5md1b1Kv9r9xWp5jZPNsjiNDMszYGFrI8Lt7fPnPSOJBn0Sxnw8zTKEv8Y3PPGolYA9S3XbUdL0fU4DfRVQkm7dOzX0oQi0X/FYIHaLJdRdandJKIy6h3kCjFCLeicj4K73jhX7POK2u54NE5+HzjD6XE/Ig3e1gusTzQlXEPOIeQ1qeuEr2FWSsjqDrkGdOtHu/F2qydoFiHT3/f8W/zKD+wm74AbT6u/1V6rgpmxH0bpN2N3PyLPmzTofQw+ivxKGGbqcIZxdNSf5W1GPp4d7xua1Ax3F/9ju/+wJSYRvfMIzrifseX9fkGx9rbWIIZXWrro0yzCGeNq4ToRuyPo08wi0U5wSnkXYotPCVVsJhWYQV5CHdg7iN32GQB1kF/oxqp36TsA2dn4VGrvEp0j/H2s76E8f1ELKEKC5a6H6d8L5rVJ6phaWhkUXNbB5U6Fr7BcuLqOEdDG6zbA9HFRX2PszwdJHnEzf/rK7tFOUkIjahXT/8+7mG5lUoisqFFlrph+0EcBG51VXIspQFl4coq3nXPDJqX2TQuBfthLdAP+8xCgO0QJgPuEi2RMQuInI+FOK6hOfxmH+3UYcs1yzR/BuWTTbK4Aco41cEbocLP4w7xDqF9DtRWtdP0V1ARqeqBY1F4KrDL1MwxnXg8xO2WpdRcNkGfo3IIIxCpOgWwOZ1y90QNGR8XA/HeMjdDBq+oruLjAP3Ig9noffa1XulCV1NJ1WEZJ9D3nPICbmIFod1R7v3Qw+hTFgdVpG8cI1PmV0ZQ/12y+YoLJweRTdJl5MpMlGNnI/zMreh3SkWCG8ztIaSKFWDzbOraAFy99hKez6WDTw+7I0ebPeOUC/x1d73jjyLaq7cRjY+95OcYSkCN0uxHhxFCxHT72U0ofJuxEsUJbrvY3invb2Ed/uoal2hu8jdIPIiz5D+fKyi/xmS0+jGP36ccLLCHR/KeB6lwbIPG9n4uOn3IrVdIZgWZoX6ieHWCzuRxxgKDZ4gPrycR/P5RG/cwWTRCG4jNBtZ2re8C0kL1oiXGGxGBmfY3mfuGCoiXC80xmew/07ZRiLrJo8bEVsQpxQiQf0HtdV7/90olPgSYZ3UpO15v0A/d7VENu7G7UPlb8K4GWVws5ZblLEteG40xkdwRYJZ4+kG+TCHlPRJBscNUz6BUvHLKd5vY9K2HrIkRF5P2O3KsIgq3R8n3QafvtG5gtorjy2ENeMzNtdrgmC9h5trsb5ooX4+18j2wOQZXyPSCk0C5pFI8N6cn/e99DzjKpFKfaxojE+EOeDvGaMbugHQRq1H1qPLZgcV4RYpNagCXG1Q1vFtBjeqHBvM+Axjzxs0KIpQmUmR8WPUKOtBlJ6vq7EJYRrRAx36r4ltM72F/k6ZrwDvYcKu0T3EC74aNCgL+xH/Mkxhb+MKytosUM20+qhwCPV2PsegSHgK8UFnkEBx4rATFfCVrW9p0MCF36cnLmR6kOru0joOtIA3UeFyKGPgPznuA2lQW4Ta/S4DT6GUcRPyb1BYA6PG+DRYT9xGpFh+jmq35G1QIqaoR1+UBpONOSQOrFODutrj/wAUtKIU2C+T0wAAAABJRU5ErkJggg==\");', "examsign;");
						}
            
						let style = this.css2Json(tempStyle)
						if (model === "qrcode") {
							style.backgroundImage = `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAABlBMVEX///8AAABVwtN+AAABDElEQVRo3u3ZQQ7DIAwEwOTkZ+X/v8gzuLUIb+wYpNwqNfbuARGY3lY0tBvzFzk+nvGog9yWT7L8TGxYmXdlk77kg0bI8rLRhnZ1yDb3UQ+yGkyw/sh0iSwd081n1kNWiWnWSo2QJWaWyCyBWX3IErKema0BCyFLya6GtGuma/4i0ciSM0+LDIfDmOiTrod7CNmrmccLcxpDVQSbXh8IIUvKUBpd8k/hINGQJWf2qoiDxGYxR2TbTpaITTknOJhbfJQsKZtvlLeuYJesBtPBH53FL5LIuhCyF7LlryXE7wuReZHwqoGBrALD7H6QkJVhy69PK8OhsZPVYBpj8eJJlphZQkO8OmS1GfPDfAHsX5S+uaOtDgAAAABJRU5ErkJggg==")`;
						}
            	if (model === "checksign") {
							style.backgroundImage = `url("data:image/png;base64,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")`;
               style.backgroundSize = '100px 50px'
						}
            	if (model === "examsign") {
							style.backgroundImage = `url("data:image/png;base64,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")`;
              style.backgroundSize = '100px 50px'
						}
						let data = this.getDragByModel(model);
						data.style = style;
						if (model === 'title' || model === 'remark' || model === 'line') {
							data.editLabel = childs[i].innerText;
						}
						this.editorList.push(data);
					}
      }, 10);
    },
    getDragByModel(model) {
      for (let i = 0; i < this.dragFieldList.length; i++) {
        if (this.dragFieldList[i].model === model) {
          return JSON.parse(JSON.stringify(this.dragFieldList[i]));
        }
      }
      return null;
    },
    css2Json(css) {
      css = css.replaceAll(" ", "");
      let arrs = css.split(";");
      let data = {};
      arrs.forEach((item) => {
        if (item == null || item.length === 0) {
          return;
        }
        let keyValue = item.split(":");
        let key = keyValue[0];
        let value = keyValue[1];
        data[key] = value;
      });
      return data;
    },
    resetEditorElement() {
      for (let i = 0; i < this.editorList.length; i++) {
        this.editorList[i].style.outline = "0";
      }
    },
    exports() {
      this.resetEditorElement();
      let list = JSON.parse(JSON.stringify(this.editorList));
      list.forEach((item) => {
        if (
          item.model === "title" ||
          item.model === "remark" ||
          item.model === "line"
        ) {
          return;
        }
        item.editValue = "{" + item.model + "}";
      });
      this.exportList = list;
      setTimeout(() => {
        this.dom = document.querySelector("#exportHtmlLayout");
        console.log(this.dom);
        console.log(this.dom.innerHTML);
        var listHtml = this.dom.innerHTML
        // listHtml = listHtml.replaceAll("&quot;","'")
        listHtml = listHtml.replaceAll("{qrcode}","")
        listHtml = listHtml.replaceAll("{examsign}","")
        listHtml = listHtml.replaceAll("{checksign}","")
        depot
          .post({
            url: "/v1/report/template/addTemplate",
            data: {
              name: this.value,
              template: listHtml,
              defaults: this.defaults
            },
          })
          .then((res) => {
            this.$router.push({
              path: "/report/template",
            });
            console.log(res);
            this.$message({
              type: "success",
              message: res.data,
            });
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "error",
              message: err.data,
            });
          });
      }, 100);
    },
    prev() {
      this.resetEditorElement();
      this.prevStatus = !this.prevStatus;
      if (!this.prevStatus) {
        return false;
      }
      let data = JSON.parse(JSON.stringify(this.editorList));
      data.forEach((item) => {
        this.mockFakeData(item);
      });
      this.prevEditorList = data;
    },
    mockFakeData(data) {
      switch (data.model) {
        case "studyNo":
          data.editValue = "MR147331";
          break;
        case "deviceNo":
          data.editValue = "Sequoia 512";
          break;
        case "username":
          data.editValue = "野比大雄";
          break;
        case "gender":
          data.editValue = "男";
          break;
        case "age":
          data.editValue = "46 岁";
          break;
        case "studyDatetime":
          data.editValue = "2021-05-11 12:12:12";
          break;
        case "department":
          data.editValue = "神经外科";
          break;
        case "checkNo":
          data.editValue = "000187962";
          break;
        case "bedNo":
          data.editValue = "/";
          break;
        case "liveNo":
          data.editValue = "/";
          break;
        case "applyDoctor":
          data.editValue = "路飞";
          break;
        case "diagnosis":
          data.editValue = "颅内损伤";
          break;
        case "body":
          data.editValue = "双肾输尿管膀胱|前列腺";
          break;
        case "desc":
          data.editValue =
            "两侧大脑半球对称，脑实质内未见明确异常密度影。两侧脑室脑池对称性增宽扩大。脑沟增宽，中线结构居中。颅骨完整。";
          break;
        case "remind":
          data.editValue = "老年性脑改变，请结合临床";
          break;
        case "checkDoctor":
          data.editValue = "张大炮";
          break;
        case "examDoctor":
          data.editValue = "律政先锋";
          break;
        case "reportDatetime":
          data.editValue = "2021-05-11 14:14:14";
          break;
      }
    },
  },
  watch: {
    fontSizeValue(newData, oldData) {
      if (this.clickElementData == null) {
        return false;
      }
      this.editorList[this.clickElementData.index].style.fontSize =
        newData + "px";
    },
    fontWeightValue(newData, oldData) {
      if (this.clickElementData == null) {
        return false;
      }
      this.editorList[this.clickElementData.index].style.fontWeight = newData;
    },
    editContentValue(newData, oldData) {
      if (this.clickElementData == null) {
        return false;
      }
      this.editorList[this.clickElementData.index].editLabel = newData;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.search_input {
  width: 100%;
}
.my_drag {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;

  -moz-user-select: none;

  -webkit-user-select: none;

  user-select: none;
}
.lefts div:first-child {
  box-sizing: border-box;
  padding: 10px 7px 0 5px;
}
.lefts {
  display: flex;
  flex-direction: column !important;
}
.left {
  flex: 2;
  display: flex;
  flex-flow: row wrap;
  padding: 10px 0 0 10px;
  box-sizing: border-box;
  align-content: flex-start;
  background: #ffffff;
}

.left span {
  flex: 0 0 45%;
  display: inline-block;
  border: 1px solid #ddd;
  cursor: grab;
  margin-bottom: 10px;
  text-align: center;
  color: #333;
  padding: 5px 0px;
  margin-right: 10px;
}

.center {
  flex: 6;
  flex-shrink: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #f5f7f9;
  position: relative;
}

.center::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}

.center::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
}

.editor {
  width: 700px;
  height: 1000px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  font-family: "Alibaba PuHuiTi Medium";

  background-image: linear-gradient(rgba(150, 150, 150, 0.1) 1px, transparent 0),
    linear-gradient(90deg, rgba(150, 150, 150, 0.1) 1px, transparent 0),
    linear-gradient(rgba(225, 225, 225, 1) 1px, transparent 0),
    linear-gradient(90deg, rgba(225, 225, 225, 1) 1px, transparent 0);
  background-size: 5px 5px, 5px 5px, 20px 20px, 20px 20px;
  /*		background-image:
					linear-gradient(rgba(245,245,245,1) 1px, transparent 0),
					linear-gradient(90deg, rgba(245,245,245,1) 1px, transparent 0),
					linear-gradient(rgba(233,233,233,1) 1px, transparent 0),
					linear-gradient(90deg, rgba(233,233,233,1) 1px, transparent 0);
				background-size: 15px 15px, 15px 15px, 75px 75px, 75px 75px;*/
}

.editor_prev {
  width: 700px;
  height: 1000px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  font-family: "Alibaba PuHuiTi Medium";
  z-index: 2;
  top: 0;
}

.editor div {
  cursor: move;
}

.right {
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  padding: 0 10px;
}

.right_attrs {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.right_attrs b {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  font-weight: normal;
}

.right_action {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.right_final_action {
  margin-top: 30px;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/template/index.vue